import { useEffect, useState } from "react";
import axios from "axios";

import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";

import "../../utils/chartSetup";
import "./dashboard.css";

import { Line, Doughnut } from "react-chartjs-2";

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await axios.get("http://localhost:5000/api/dashboard");
      setStats(res.data);
    } catch (err) {
      console.error("Dashboard error", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !stats) {
    return (
      <div className="admin-body">
        <Topbar />
        <Sidebar />
        <main className="admin-main">
          <p style={{ padding: 20 }}>Loading dashboard...</p>
        </main>
        <Footer />
      </div>
    );
  }

  /* ===============================
     CHART DATA
  ================================ */

  const revenue = Number(stats.totalRevenue || 0);

  const revenueData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    datasets: [
      {
        label: "Revenue",
        data: [
          revenue * 0.25,
          revenue * 0.35,
          revenue * 0.45,
          revenue * 0.6,
          revenue * 0.75,
          revenue * 0.9,
          revenue
        ],
        borderColor: "#0d6efd",
        backgroundColor: "rgba(13,110,253,0.2)",
        fill: true,
        tension: 0.4
      }
    ]
  };

  const orderStatusData = {
    labels: ["Completed", "Pending", "Cancelled"],
    datasets: [
      {
        data: [
          stats.orders || 0,
          stats.rfqs || 0,
          Math.max((stats.orders || 0) - (stats.rfqs || 0), 1)
        ],
        backgroundColor: ["#2ecc71", "#f1c40f", "#e74c3c"],
        borderWidth: 0
      }
    ]
  };

  /* ===============================
     RENDER
  ================================ */

  return (
    <div className="admin-body">
      <Topbar />
      <Sidebar />

      <main className="admin-main">
        <h2 className="dashboard-title">Dashboard</h2>

        {/* STATS */}
        <div className="stats-grid">
          <div className="stat-card blue">
            <h4>Total Revenue</h4>
            <h2>₹{revenue.toLocaleString()}</h2>
            <span>↑ This month</span>
          </div>

          <div className="stat-card green">
            <h4>Orders</h4>
            <h2>{stats.orders}</h2>
            <span>↑ Active orders</span>
          </div>

          <div className="stat-card purple">
            <h4>Products</h4>
            <h2>{stats.products}</h2>
            <span>Active items</span>
          </div>

          <div className="stat-card orange">
            <h4>RFQs</h4>
            <h2>{stats.rfqs}</h2>
            <span>New requests</span>
          </div>
        </div>

        {/* CHARTS */}
        <div className="charts-grid">
          <div className="chart-card">
            <h3>Sales Overview</h3>
            <Line data={revenueData} />
          </div>

          <div className="chart-card">
            <h3>Order Status</h3>
            <Doughnut data={orderStatusData} />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
